import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ApprovalService } from '../../../services/approval.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  claims: any = {};
  isLogin: boolean = false;
  titlePage = 'tesst';
  icon = 'bar-chart';

  userName: any = '';
  isShowBack = true;

  menu: any;
  constructor(
    private auth: AngularFireAuth,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private approvalService: ApprovalService
  ) {}

  ngOnInit(): void {
    this.isLogin = true;
    this.userName = localStorage.getItem('userNameDisplay');
    this.approvalService.currentApprovalStageShowIcon.subscribe(
      (x) => (this.isShowBack = x)
    );
    this.approvalService.currentApprovalStageMenu.subscribe(
      (x) => (this.menu = x)
    );
  }

  logout() {
    this.auth.signOut().then(() => {
      this.router.navigate(['/fox-admin/login']);
    });
    localStorage.clear();
  }

  goBack() {
    this.location.back();
  }
}
